import React, { useEffect, useState } from "react";
import "./BookingSuccess.css";
import { useNavigate, useParams, useLocation } from "react-router-dom";

function BookingSuccessPage() {
  const navigate = useNavigate();
  const { bookingRef } = useParams();
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const paymentId = query.get("paymentId");
  const orderId = query.get("orderId");
  const amount = query.get("amount");


  return (
    <div className="bookingSuccessContainer">
      <div className="bookingCard">
        <div className="iconWrapper">
          <svg
            className="icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            ></path>
          </svg>
        </div>

        <h1 className="title">Booking Successful!</h1>
        <div className="detailsSection">
          <div className="detailItem">
            <span className="label">Booking Reference</span>
            <span className="value">{bookingRef}</span>
          </div>
          <div className="detailItem">
            <span className="label">Payment ID</span>
            <span className="value">{paymentId}</span>
          </div>
          <div className="detailItem">
            <span className="label">Order ID</span>
            <span className="value">{orderId}</span>
          </div>
          <div className="detailItem">
            <span className="label">Amount Paid</span>
            <span className="amountValue">₹{amount}</span>
          </div>
        </div>
        <button className="actionButton" onClick={() => navigate("/")}>
          Back to Home
        </button>
      </div>
    </div>
  );
}

export default BookingSuccessPage;
